







































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import TreeNodeDialog from './components/tree-node-dialog.vue';
import RgFileEdit from './fileEdit.vue';
import * as api from '@/api';
import ImportArchiveModal from './components/import-archive-modal.vue';
/**
 * rg问题归档
 *
 * @author liyuyao
 * @date 11/07/2020
 */
@Component({
    components: {
        TreeNodeDialog,
        RgFileEdit,
        ImportArchiveModal
    }
})
export default class RgFile extends Vue {
    openFile: boolean = false;
    fileRequired: boolean = false;
    archiveRequire: boolean = false;
    showImportModal: boolean = false;

    data: any = [];

    createDialogVisble: boolean = false;
    editDialogVisble: boolean = false;
    // 当前选中节点
    node: any = {
        ruleId: -1,
        depth: -1,
        itemId: 0,
        nodeName: '',
        inUse: false
    };
    $refs: { fileEdit: RgFileEdit };
    showEdit: boolean = false;
    checkNode: any = null;
    activeName: string = 'content';
    archiveRequireEnd: boolean = false;
    rgCloseReasonField: any = [];
    openArchiveCloseReason: boolean = false;
    showCloseReasonImportModal: boolean = false;
    @Watch('showImportModal', { immediate: true })
    showImportModalChange(val) {
        if (val === false) {
            this.showCloseReasonImportModal = false;
        }
    }

    async mounted() {
        this.getRgFileSetting();
        this.getCloseReasonField();
        this.getDefaultSetting();
    }
    async getRgFileSetting() {
        const res = await api.ctiApi.getRgFileSetting(this.rgId);
        if (res && res.code === 200) {
            this.openFile = res.data.active;
            this.archiveRequire = res.data.archiveRequire;
            this.archiveRequireEnd = res.data.archiveRequireEnd;
            const root = res.data.rootNode;
            if (root) this.data = [root];
        }
    }
    async openFileChange(open) {
        this.showEdit = open && this.node.ruleId !== -1;
        if (!open) {
            this.$refs.fileEdit.resetForm();
            this.node.ruleId = -1;
        }
        const res = await api.ctiApi.fileActive(this.rgId, open);
        if (res && res.code === 200) {
            this.$mtd.message.success('操作成功');
            const root = res.data.rootNode;
            if (root) this.data = [root];
        }
    }
    async archiveLastLevelChange() {
        const res = await api.ctiApi.setArchiveRequireEnd(this.rgId, this.archiveRequireEnd);
        if (res && res.code === 200) {
            this.$mtd.message.success('操作成功');
        }
    }
    async archiveRequireChange() {
        const res = await api.ctiApi.setArchiveSetting(this.rgId, this.archiveRequire);
        if (res && res.code === 200) {
            this.$mtd.message.success('操作成功');
        }
    }

    async loadData(node, callback) {
        const result = await this.getNodesByParent(node.data.id);
        callback(result);
    }
    async getNodesByParent(parentId: number) {
        const res = await api.ctiApi.getNodesByParent(parentId);
        return res.data.items || [];
    }
    openImportModal() {
        this.showImportModal = true;
    }
    async createExportTask() {
        const res = await api.ctiApi.exportArchive(this.rgId);
        const { data, code } = res;
        if (code === 200 && data) {
            this.$mtd.message.success(data);
        }
    }
    updateTree(id: number) {
        id && this.$set(this.checkNode.data, 'ruleId', id);
    }
    addNode(node, data) {
        const { id } = node.data;
        this.$mtd
            .confirm({
                title: '添加子分类',
                message: '分类名称：<input id="file-add-node" class="mtd-input" style="width: 280px" />',
                dangerouslyUseHTMLString: true,
                onOk: async () => {
                    const inputElement = document.getElementById('file-add-node') as HTMLInputElement;
                    const nodeText = inputElement.value;
                    if (nodeText.length) {
                        try {
                            const res = await api.ctiApi.addNodes({
                                parentId: id,
                                name: nodeText
                            });
                            if (res && res.code === 200) {
                                const newData = res.data;
                                const newChildren = data.children ? data.children.concat(newData) : newData;
                                // data.children = newChildren;
                                this.$nextTick(() => {
                                    this.$set(data, 'children', newChildren);
                                    this.$set(data, 'leaf', false);
                                });
                                // this.$set(data, 'children', newChildren);
                                this.$mtd.message.success('操作成功');
                            }
                        } catch (e) {
                            console.log('e', e);
                        }
                    }
                }
            })
            .catch(e => e);
    }
    editNode(node, data) {
        const { id } = node.data;
        this.$mtd
            .confirm({
                title: '编辑分类名称',
                message: `分类名称：<input id="file-edit-node" class="mtd-input" style="width: 280px" value="${node.data.name}" />`,
                dangerouslyUseHTMLString: true,
                onOk: async () => {
                    const inputElement = document.getElementById('file-edit-node') as HTMLInputElement;
                    const nodeText = inputElement.value;
                    if (nodeText.length && nodeText.length < 200) {
                        const res = await api.ctiApi.updateNodes({
                            id: id,
                            name: nodeText
                        });
                        if (res && res.code === 200) {
                            this.$nextTick(() => {
                                this.$set(data, 'name', nodeText);
                            });
                            this.$mtd.message.success('操作成功');
                        }
                    } else {
                        this.$mtd.message.error('分类名称限200字');
                    }
                }
            })
            .catch(e => e);
    }
    useStatusChange(node) {
        const { data } = node;
        this.$mtd
            .confirm({
                message: `${data.inUse ? '停用' : '启用'}此分类吗？`,
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: data.inUse ? '停用' : '启用',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    const res = await api.ctiApi.updateNodes({
                        id: data.id,
                        inUse: !data.inUse
                    });
                    if (res && res.code === 200) {
                        this.$mtd.message({
                            message: '操作成功',
                            type: 'success'
                        });
                        if (data.id === this.node.itemId) {
                            this.node.inUse = !data.inUse;
                        }
                        this.$set(data, 'inUse', !data.inUse);
                    }
                }
            })
            .catch(e => e);
    }
    confirmDeletion(node) {
        const { data } = node;
        this.$mtd
            .confirm({
                message: '<p>删除后历史数据无法保留 <br><br> 删除后，当前问题归档下存在的历史工单将处于“未分类”状态，是否确认删除？</p>',
                dangerouslyUseHTMLString: true,
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确认',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    const res: any = await api.ctiApi.deleteArchiveNode({ id: data.id });
                    if (res && res.code === 200) {
                        this.$mtd.message({
                            message: '操作成功',
                            type: 'success'
                        });

                        // 获取 parent 节点信息，并更新 parent 节点的 { children, leaf } 和属性
                        const parentNode = node.$parent;
                        const res = await api.ctiApi.getArchiveTreeByParent(parentNode.data.id);
                        const resData = res.data;

                        this.$set(parentNode.data, 'children', resData.children);
                        this.$set(parentNode.data, 'leaf', resData.leaf);
                    }
                }
            })
            .catch(async e => {
                // 点击取消按钮会执行到这里（为啥要把取消按钮当成 error 来 catch 😒
                console.log(e);
            });
    }
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
    async clickHandler(node) {
        this.$refs.fileEdit.resetForm();
        this.checkNode = node;
        this.node = {
            itemId: node.data.id,
            depth: node.data.depth,
            ruleId: node.data.ruleId || 0,
            nodeName: node.data.name,
            inUse: node.data.inUse
        };
        this.showEdit = !!node.level;
    }
    async getCloseReasonField() {
        const res = await api.rgApi.getRgReplyField({ rgId: this.rgId, type: 'CLOSED_REASON' });
        if (res && res.code === 200) {
            this.rgCloseReasonField = res?.data?.items;
        }
    }
    async getDefaultSetting() {
        const res = await api.rgApi.getRgSetting(this.rgId);
        const { code, data } = res;
        if (code === 200) {
            this.openArchiveCloseReason = data.archiveCloseReasonSwitch === 'on';
        }
    }
    async openArchiveCloseReasonChange(open) {
        const requestBody = {
            rgId: this.rgId,
            archiveCloseReasonSwitch: open ? 'on' : 'off'
        };
        try {
            const res = await api.rgApi.sendRgSetting(requestBody);
            const { code, data } = res;
            if (code === 200) {
                this.$mtd.message.success('修改成功');
                if (data?.archiveCloseReasonSwitch) {
                    this.openArchiveCloseReason = data?.archiveCloseReasonSwitch === 'on';
                }
            }
        } catch (e) {
            this.$mtd.message.error(`修改失败，原因：${e}`);
        }
    }
    openCloseReasonImportModal() {
        this.showImportModal = true;
        this.showCloseReasonImportModal = true;
    }
    async createCloseReasonExportTask() {
        const res = await api.ctiApi.exportCloseReason(this.rgId);
        const { data, code } = res;
        if (code === 200 && data) {
            this.$mtd.message.success(data?.message);
        } else {
            this.$mtd.message.error(data?.message);
        }
    }
}
